import React, { useEffect, useState } from 'react';
import { DataView } from 'primereact/dataview';
import { Notify } from "@shared/ui-native/Notify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button } from "@shared/ui-react/Button";
import { InputText } from 'primereact/inputtext';
import { Ajax2 } from '@shared/Ajax';
import './FileInfoDialog.scss';
import './OrthoInfoDialog.scss';

const domain = kuura.AwsApiGatewayDomain();
//const domain = "http://localhost:8000";

type MapDetailsResponse = {
    XYZ: string;
    WMTS: string;
    state: number;
}

type MapDetailsProps = {
    project_uuid: string;
    file_uuid: string;
}

export const OrthoInfoDialog: React.FC<MapDetailsProps> = ({ project_uuid, file_uuid }) => {
    const [mapDetails, setMapDetails] = useState<MapDetailsResponse | null>(null);

    useEffect(() => { 
        const fetchMapDetails = async () => {
            try {
                const path = 'v1/reality-capture/raster/map-details';
                const url = new URL(path, domain).toString();
                const params = new URLSearchParams({
                    project_uuid: project_uuid,
                    model_uuid: file_uuid
                });
                const fetchUrl = `${url}?${params.toString()}`;
                const response = await Ajax2({ url: fetchUrl, useToken: true, method: "GET" });
                
                setMapDetails(response);
            } catch (err) {
                console.error(err);
            }
        };

        fetchMapDetails();
        const intervalID = setInterval(fetchMapDetails, 3000);

        return () => {
            clearInterval(intervalID);
        };
    }, [project_uuid, file_uuid]);

    if (!mapDetails) {
        return (
            <div className="flex-column gap-half">
                <div className="card of-a" id="custom-container" style={{ justifyContent: 'center' }}>
                    <div className="ik-spinner-loader" />
                </div>
            </div>
        );
    }

    const processingClass = mapDetails.state < 100 ? 'faded' : '';
    const processingClassText = mapDetails.state < 100 ? 'faded-text' : '';

    return (
        <div className="flex-column gap-half">
            <div className="card of-a" id="custom-container">
                <DataView
                    value={[
                        { label: "XYZ", value: mapDetails.XYZ },
                        { label: "WMTS", value: mapDetails.WMTS }
                    ]}
                    layout="list"
                    itemTemplate={(item) => (
                        <div className="ortho-info-item">
                            <div className="ortho-info-label">{item.label}</div>
                            <InputText
                                className={`file-info-ortho-link ${processingClassText}`}
                                value={item.value}
                                readOnly
                            />
                            <CopyToClipboard text={item.value} onCopy={() => Notify.success('Copied')}>
                                <Button className={`ik-button-small ${processingClass}`}>{__('js_map.copy_to_clipboard')}</Button>
                            </CopyToClipboard>
                        </div>
                    )}
                />
                {mapDetails.state < 0 &&
                    <div className="error-container">
                        <div className="error-text">{__('js_files.msg.notifications.server_error')}!</div>
                    </div>
                }
                {(0 <= mapDetails.state && mapDetails.state < 100) &&
                    <div className="ik-map-loader" />
                }
            </div>
        </div>
    );
};
